import BaseAPI from '@/apis/base/baseApi';

export default class FAApi extends BaseAPI {
  apiName = 'FA';
}
